import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { getCameraStreamFailed, getCameraStreamSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* getCameraStream(action) {
  try {
    const id = action.payload;
    const url = `${BACKEND_URL}/camera/${id}/stream`;
    const dataResponse = yield makeRequest(url, { hostless: true }, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(getCameraStreamSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(getCameraStreamFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(getCameraStreamFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
